import {OPENID_SCOPES} from './constants'

/**
 * What the admin OAuth scopes page needs to know about a scope that the API does not tell it.
 *
 * A scope names a resource. The auth service gives every resource scope the same read and write
 * permissions, and clients ask for them as `resource:read` and `resource:write`. The sign-in scopes
 * (openid, profile, email) get none, and are requested by their bare name. The listing returns the
 * scopes and the permissions side by side without linking them, so these helpers put the two back
 * together from that rule.
 *
 * The resource rules match the server's: it trims and lowercases what it is sent, and rejects
 * anything that is not one word, since a space or a colon would split the name apart when a
 * client's requested scopes are parsed.
 */
export const RESOURCE_PATTERN = /^[a-z0-9_-]+$/

export const normalizeResource = resource => resource.trim().toLowerCase()

export const isSignInScope = scope => OPENID_SCOPES.includes(scope.resource)

export const scopePermissions = ({resource, permissions}) => {
  const byCategory = new Map(permissions.map(permission => [permission.category, permission]))

  return [...byCategory.values()].map(permission => ({...permission, name: `${resource}:${permission.category}`}))
}

export const matchesQuery = query => scope => {
  const needle = query.trim().toLowerCase()

  return !needle || scope.resource.includes(needle) || scope.description.toLowerCase().includes(needle)
}
